export const TAGS = {
  ACCOUNT_RELATED: 'accountRelated',
  ORDERS: 'pwcOrders',
  ORDER: 'pwcOrder',
};
